import React from 'react';
import VideoCard from './VideoCard';

const factories = [
  {
    name: 'Planta Gaoling',
    location: 'Distrito Gaoling, Xi\'an, Shaanxi',
    image: 'https://rixingroup.cn/wp-content/uploads/2023/05/112-%E6%8B%B7%E8%B4%9D.jpg',
    video: 'https://rixingroup.cn/wp-content/uploads/2023/05/%E8%87%AA%E5%BB%BA%E7%AB%99%E5%85%AC%E5%8F%B8%E8%A7%86%E9%A2%91.mp4',
    highlights: [
      'Líneas de producción automatizadas',
      'Almacén de materias primas certificado',
      'Control de calidad en línea',
    ],
  },
  {
    name: 'Planta Pucheng',
    location: 'Condado Pucheng, Shaanxi',
    image: 'https://rixingroup.cn/wp-content/uploads/2025/07/06e9960e84f8ac8f532689b8ce3e9697_720.jpg',
    video: 'https://rixingroup.cn/wp-content/uploads/2025/07/%E9%AB%98%E5%AD%977%E6%9C%8811%E6%97%A51.mp4',
    highlights: [
      'Producción a gran escala de demulsificantes',
      'Centro de I+D integrado',
      'Planta piloto para nuevas formulaciones',
    ],
  },
];

export default function RixinFactories() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 md:mb-18">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-building-4-line text-sm w-4 h-4 flex items-center justify-center" />
              Infraestructura de Producción
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Dos Plantas de Producción <span className="text-primary-500">en Shaanxi, China</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Rixin Group opera dos modernas plantas manufactureras con tecnología de punta para la formulación
              y producción de demulsificantes y otros productos químicos especializados para la industria petrolera.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            {factories.map((factory) => (
              <div
                key={factory.name}
                className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300"
              >
                {/* Video */}
                <VideoCard
                  src={factory.video}
                  poster={factory.image}
                  title={factory.name}
                  subtitle={`${factory.location} — Video oficial`}
                />

                <div className="p-6 md:p-8">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                      <i className="ri-building-4-line text-sm" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-foreground-950">{factory.name}</h3>
                      <p className="text-foreground-500 text-xs">{factory.location}</p>
                    </div>
                  </div>
                  <ul className="space-y-2">
                    {factory.highlights.map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                          <i className="ri-check-line text-primary-500 text-xs" />
                        </div>
                        <span className="text-foreground-600 text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}